import { JourneyConstructionRuleService } from 'src/app/angularJS/services/journey-construction-rule/journey-construction-rule.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { TransportLocationService } from 'src/app/angularJS/services/transport-location/transport-location.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { TransportOperatorService } from 'src/app/angularJS/services/transport-operator/transport-operator.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { TransportOperatorServicesService } from 'src/app/angularJS/services/transport-operator-services/transport-operator-services.service';

export class JourneyConstructionRuleManagerController {
  public static $inject = [
    'journeyConstructionRuleService',
    'journeyConstructionRule',
    'breadcrumbService',
    'userService',
    'LinkBuilder',
    'transportLocationService',
    'QueryBuilder',
    '$q',
    '$translate',
    'UserMessages',
    '$state',
    'ACTToolbarService',
    'transportOperatorService',
    'transportOperatorServicesService'
  ];

  public selectedOperator: InterACT.Interfaces.TransportOperators.TransportOperator | InterACT.Interfaces.UsageEvents.OperatorLink;
  public selectedService: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService | InterACT.Interfaces.JourneyConstructionRules.TransportOperatorServiceLink;
  public operatorSearchText: string = '';
  public serviceSearchText: string = '';
  public selectedOrigin: InterACT.Interfaces.TransportLocations.TransportLocation | InterACT.Interfaces.UsageEvents.TransportLocationLink;
  public originSearchText: string = '';
  public selectedDestination: InterACT.Interfaces.TransportLocations.TransportLocation | InterACT.Interfaces.UsageEvents.TransportLocationLink;
  public destinationSearchText: string = '';
  public currentLocale: string;
  public journeyConstructionRuleTypes = [
    'SAME_LOCATION_EXIT_TIME',
    'MAXIMUM_JOURNEY_TIME',
    'USAGE_VALIDITY_PERIOD',
    'DOUBLE_TAP',
    'SAME_DEVICE_TRIP',
    'BREAK_OF_JOURNEY',
    'REPLACEMENT_VEHICLE'
  ];
  public possibleDirections = [
    'INBOUND',
    'OUTBOUND',
    'CLOCKWISE',
    'ANTICLOCKWISE'
  ]
  showServiceDropdown: boolean;

  private REPLACEMENT_VEHICLE = 'REPLACEMENT_VEHICLE';

  constructor(
    private journeyConstructionRuleService: JourneyConstructionRuleService,
    public journeyConstructionRule: InterACT.Interfaces.JourneyConstructionRules.JourneyConstructionRule,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    public transportLocationService: TransportLocationService,
    private queryBuilder: QueryBuilder,
    private $q: ng.IQService,
    private $translate: ng.translate.ITranslateService,
    private userMessagesService: UserMessagesService,
    private $state: ng.ui.IStateService,
    private toolbarService: ACTToolbarService,
    private transportOperatorService: TransportOperatorService,
    private transportOperatorServicesService: TransportOperatorServicesService) {
    this.activate();
  }


  /**
   * A method that ensures that both locations have a value if both are required
   */
  public bothLocationsRequired() {
    if (this.journeyConstructionRule.type === this.REPLACEMENT_VEHICLE) {
      // Null safe way of accessing the location names that stops typescript throwing a wobbly
      if((this.journeyConstructionRule.origin||<InterACT.Interfaces.TransportLocations.TransportLocation>{}).locationName 
              || (this.journeyConstructionRule.destination||<InterACT.Interfaces.TransportLocations.TransportLocation>{}).locationName)
      {
        return true
      }
    }

    return false;
  }

  /**
   * A method that handles the case where the rule creation has been cancelled
   */
  public onCancel = () => {
    this.$state.go('journey-construction-rules');
  };

  /**
   * A method that cleans the journey contruction model on a rule type change
   */
  public onRuleTypeChange = () => {
    if (this.journeyConstructionRule.type === 'SAME_DEVICE_TRIP') {
      this.journeyConstructionRule.direction = undefined;
      this.journeyConstructionRule.timePeriod = undefined;
    }

    if (this.journeyConstructionRule.type === 'BREAK_OF_JOURNEY') {
      this.journeyConstructionRule.timePeriod = undefined;
    }

    if (this.journeyConstructionRule.type === this.REPLACEMENT_VEHICLE) {
      this.journeyConstructionRule.direction = undefined;
    }

    this.showServiceDropdown = this.journeyConstructionRule.type === 'MAXIMUM_JOURNEY_TIME';
  }

  /**
   * A method that sets the transportOperator on the rule
   * @param transportOperator the operator the set on the rule
   */
  public setOperatorOnRule = (transportOperator: InterACT.Interfaces.TransportOperators.TransportOperator) => {
    if (!transportOperator) {
      (<any>this.journeyConstructionRule).operator = undefined;
      return;
    }

    (<any>this.journeyConstructionRule).operator = {
      link: this.linkBuilder.getTransportOperatorsLink(transportOperator.id),
      name: transportOperator.name[this.currentLocale]
      //TODO: populate identifier property when we figure out which property on a full transportOperator to use to populate it with
    };

    this.selectedService = undefined;
  };

  /**
   * A method that sets the transportOperatorService on the rule
   * @param transportOperatorService the service the set on the rule
   */
  public setOperatorServiceOnRule = (transportOperatorService: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService) => {
    if (!transportOperatorService) {
      (<any>this.journeyConstructionRule).services = undefined;
      return;
    }

    (<any>this.journeyConstructionRule).services = [{
      link: this.linkBuilder.getTransportOperatorServicesLink(transportOperatorService.id),
      name: transportOperatorService.serviceNumber
    }];
  };

  /**
   * A method that determines if a field should be shown based on a given assertion
   */
  public isTypeSameDeviceTripOrBreakOfJourney = () => {
    if (this.journeyConstructionRule.type === 'SAME_DEVICE_TRIP') {
      return false;
    }

    if (this.journeyConstructionRule.type === 'BREAK_OF_JOURNEY') {
      return false;
    }

    return true;
  }

  public isTypeReplacementVehicle = () => {
    return this.journeyConstructionRule.type === this.REPLACEMENT_VEHICLE;
  }


  /**
    * A method that determines if a direction field should be shown
   */
  public isDirectionEnabled = () => {
    if (this.journeyConstructionRule.type === 'SAME_DEVICE_TRIP'
      || this.journeyConstructionRule.type === this.REPLACEMENT_VEHICLE) {
      return false;
    }

    return true;
  }

  /**
   * A method gets a list of operators whos name contains the supplied operatorName
   * @param operatorName the name or partial name of the product to retrieve
   * @returns a promise that resolves with a list of transport operators whos name contains the supplied operatorName
   */
  public getOperatorsByName = (operatorName: string) => {
    const deferred = this.$q.defer();

    if (!operatorName) {
      deferred.resolve([]);
    } else {
      const query = this.queryBuilder.newParam()
        .fieldIs('schemes.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id))
        .and()
        .fieldContains('name.' + this.currentLocale, operatorName)
        .getParam();

      this.transportOperatorService.getList(1, 1000, query).then((response) => {
        deferred.resolve(response.transportOperators);
      });
    }

    return deferred.promise;
  };

  /**
    * A method that extracts the operator name from the supplied object
    * or just returns the supplied object if it is a string
    */
  public getOperatorName = (operator: InterACT.Interfaces.TransportOperators.TransportOperator | InterACT.Interfaces.UsageEvents.OperatorLink) => {
    if (!operator) {
      return '';
    } else if (operator.name[this.currentLocale]) {
      return operator.name[this.currentLocale];
    } else {
      return operator.name;
    }
  };

  /**
  * A method that extracts the service name from the supplied object
  * or just returns the supplied object if it is a string
  */
  public getServiceName = (service) => {
    if (service && service.name) {
      return service.name;
    } else if (service && service.serviceNumber) {
      return service.serviceNumber;
    }

    return '';
  };

  /**
   * A method that saves the supplied journey construction rule
   */
  public saveRule(journeyConstructionRule: InterACT.Interfaces.JourneyConstructionRules.JourneyConstructionRule) {
    const ruleCopy = angular.copy(journeyConstructionRule);

    if (ruleCopy.type === 'SAME_DEVICE_TRIP' || ruleCopy.origin && !ruleCopy.origin.locationName) {
      delete ruleCopy.origin;
    }

    if (ruleCopy.type === 'SAME_DEVICE_TRIP' || ruleCopy.destination && !ruleCopy.destination.locationName) {
      delete ruleCopy.destination;
    }

    if (ruleCopy.type === 'SAME_DEVICE_TRIP') {
      delete ruleCopy.timePeriod;
    }

    if (ruleCopy.type === this.REPLACEMENT_VEHICLE) {
      delete ruleCopy.permitBreakOfJourney;
    }

    if (ruleCopy.id) {
      return this.journeyConstructionRuleService.update(ruleCopy).then((response) => {
        this.userMessagesService.showToast('USAGE_CONTRUCTION_RULE_UPDATED');
        this.$state.go('journey-construction-rules');
      });
    } else {
      return this.journeyConstructionRuleService.create(ruleCopy).then((response) => {
        this.userMessagesService.showToast('NEW_USAGE_CONTRUCTION_RULE');
        this.$state.go('journey-construction-rules');
      });
    }
  }

  /**
   * A method that updates the selected origin location on the journey construction rule
   */
  public updateSelected = (fieldName: string) => {
    if (fieldName === 'origin') {
      if (!this.selectedOrigin) {
        this.journeyConstructionRule.origin.locationName = undefined;
        this.journeyConstructionRule.origin.link = undefined;
        return;
      }

      
      if(!this.journeyConstructionRule.origin) {
        this.journeyConstructionRule.origin = { locationName: undefined, link: undefined };
      }
      this.journeyConstructionRule.origin.locationName = this.selectedOrigin.locationName;
      this.journeyConstructionRule.origin.link = this.linkBuilder.getTransportLocationLink((<InterACT.Interfaces.TransportLocations.TransportLocation>this.selectedOrigin).id);
    } else {
      if (!this.selectedDestination) {
        this.journeyConstructionRule.destination.locationName = undefined;
        this.journeyConstructionRule.destination.link = undefined;
        return;
      }

      if(!this.journeyConstructionRule.destination) {
        this.journeyConstructionRule.destination = { locationName: undefined, link: undefined };
      }
      this.journeyConstructionRule.destination.locationName = this.selectedDestination.locationName;
      this.journeyConstructionRule.destination.link = this.linkBuilder.getTransportLocationLink((<InterACT.Interfaces.TransportLocations.TransportLocation>this.selectedDestination).id);
    }
  }

  /**
   * A method that retrieves the transport locations that satisfy the supplied location name
   * @param locationName the name of the location to search for
   * @param collectionName the name of the collection that the results should be stored in
   */
  public getTransportLocations = (searchText: string) => {
    const deferred = this.$q.defer();
    const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
    const builder = this.queryBuilder.newParam()
      .openSubQuery()
      .fieldIs('scheme.link', schemeLink)
      .or()
      .fieldIs('scheme.link', '/globalScheme')
      .closeSubQuery();

    if (searchText) {
      builder.and().openSubQuery()
        .fieldContains('references.atcoCode', searchText)
        .or().fieldContains('references.naptanCode', searchText)
        .or().fieldContains('locationName', searchText)
        .closeSubQuery();
    }

    const query = builder.getParam();

    this.transportLocationService.getList(1, 1000, query).then((response) => {
      deferred.resolve(response.transportLocations);
    });

    return deferred.promise;
  }

  /**
   * A method that clears the transport location for the supplied field name. i.e. origin or destination
   * @param fieldName the name of the field to clear. (origin or destination)
   */
  public clearLocation = (fieldName: string) => {
    this.journeyConstructionRule[fieldName].locationName = undefined;
    this.journeyConstructionRule[fieldName].link = undefined;

    if (fieldName === 'origin') {
      this.selectedOrigin = undefined;
      this.originSearchText = '';
    } else {
      this.selectedDestination = undefined;
      this.destinationSearchText = '';
    }
  };

  /**
   * A method that gets the text that should be displayed for a transport location
   */
  public getLocationText = (transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) => {
    const locationName = transportLocation.locationName;

    if (transportLocation.references) {
      if ((<any>transportLocation.references).atcoCode) {
        return (<any>transportLocation.references).atcoCode + ' - ' + locationName;
      }

      if ((<any>transportLocation.references).naptanCode) {
        return (<any>transportLocation.references).naptanCode + ' - ' + locationName;
      }
    }

    return locationName;
  }

  /**
   * Searches for transport operator services with a service number matching 
   * the provided search text, which also match the current scheme and selected 
   * operator.
   * 
   * @param searchText the search text to match against service's service numbers
   */
  public getServicesByServiceNumber = (searchText: string) => {
    const deferred = this.$q.defer();

    if (!searchText) {
      deferred.resolve([]);
    } else {

      let operatorLink: string = (<any>this.selectedOperator).id
        ? this.linkBuilder.getTransportOperatorsLink((<any>this.selectedOperator).id)
        : (<any>this.selectedOperator).link;

      const query = this.queryBuilder.newParam()
        .fieldIs('schemes.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id))
        .and()
        .fieldContains('serviceNumber', searchText)
        .and()
        .fieldIs('operator.link', operatorLink)
        .getParam();

      this.transportOperatorServicesService.getList(1, 15, query).then((response) => {
        deferred.resolve(response.transportOperatorServices);
      });
    }

    return deferred.promise;
  }

  /**
   * A method that creates a blank journey construction rule for the users current scheme
   */
  private createBlankJourneyConstructionRule() {
    return {
      scheme: {
        link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
        abbreviation: this.userService.selectedScheme.reference
      },
      name: '',
      type: 'SAME_LOCATION_EXIT_TIME',
      validFrom: undefined,
      validUntil: undefined,
      operator: undefined,
      services: undefined,
      timePeriod: undefined,
      origin: {
        link: undefined,
        locationName: undefined
      },
      destination: {
        link: undefined,
        locationName: undefined
      },
      permitBreakOfJourney: false,
      direction: undefined
    };
  }

  /**
   * A method that is called during controller instantiation
   */
  private activate() {
    this.currentLocale = this.$translate.use();

    if (!this.journeyConstructionRule) {
      this.journeyConstructionRule = <any>this.createBlankJourneyConstructionRule();
    } else {
      this.journeyConstructionRule.validFrom = <any>new Date(<string>this.journeyConstructionRule.validFrom);

      if (this.journeyConstructionRule.validUntil) {
        this.journeyConstructionRule.validUntil = <any>new Date(<string>this.journeyConstructionRule.validUntil);
      }

      if (this.journeyConstructionRule.origin && this.journeyConstructionRule.origin.locationName) {
        this.selectedOrigin = <InterACT.Interfaces.UsageEvents.TransportLocationLink>this.journeyConstructionRule.origin;
      }

      if (this.journeyConstructionRule.destination && this.journeyConstructionRule.destination.locationName) {
        this.selectedDestination = <InterACT.Interfaces.UsageEvents.TransportLocationLink>this.journeyConstructionRule.destination;
      }

      if (this.journeyConstructionRule.operator && this.journeyConstructionRule.operator.name) {
        this.selectedOperator = <InterACT.Interfaces.UsageEvents.OperatorLink>this.journeyConstructionRule.operator;
      }

      if (this.journeyConstructionRule.services && this.journeyConstructionRule.services.length > 0) {
        this.selectedService = <InterACT.Interfaces.JourneyConstructionRules.TransportOperatorServiceLink>this.journeyConstructionRule.services[0];
      }

      if ('MAXIMUM_JOURNEY_TIME' === this.journeyConstructionRule.type) {
        this.showServiceDropdown = true;
      }
    }

    this.breadcrumbService.setBreadcrumbs([{
      name: 'ABT_CONFIGURATION',
      sref: '#'
    }, {
      name: 'USAGE_CONSTRUCTION_RULES',
      sref: 'journey-construction-rules'
    }, {
      name: this.journeyConstructionRule.id ? 'EDIT_USAGE_CONSTRUCTION_RULE' : 'CREATE_USAGE_CONSTRUCTION_RULE',
      sref: 'journey-construction-rule-manage',
      params: {
        id: this.journeyConstructionRule && this.journeyConstructionRule.id ? this.journeyConstructionRule.id : undefined
      }
    }]);

    this.toolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle(this.journeyConstructionRule.id ? 'EDIT_USAGE_CONSTRUCTION_RULE' : 'CREATE_USAGE_CONSTRUCTION_RULE');
    });
  }
}
